export type {
  VitalsFormDto as VitalsFormData,
  SaveVitalsFormDto as SaveVitalsFormRequest,
  VitalsFormConfirmedDto as VitalsFormConfirmedData,
} from '@generated/models'

export {BloodPressureCategory, GenderDto} from '@generated/models'
